import React from 'react';
import { DropdownItemProps, Modal } from 'semantic-ui-react';

import '../ws/worldspinner.css';
import './ColorDropdown.css';
import '../components/HeraldryWidget.css';

interface Props {
    color: string | undefined;
    onChange: (color: string) => void;
    onClose: () => void;
    disabled?: boolean;
    historical: boolean;
}
interface State {
}

export class ColorDropdownModal extends React.Component<Props, State> {

    static colorImg = require("../assets/colors/SILVER.png");

    static historicalOptions = [
        { key: 'RED', text: 'Red', value: 'RED', image: require("../assets/colors/RED.png") },
        { key: 'ORANGE', text: 'Orange', value: 'ORANGE', image: require("../assets/colors/ORANGE.png") },
        { key: 'GOLD', text: 'Gold', value: 'GOLD', image: require("../assets/colors/GOLD_BORDER.png") },
        { key: 'GREEN', text: 'Green', value: 'GREEN', image: require("../assets/colors/GREEN.png") },
        { key: 'BLUE', text: 'Blue', value: 'BLUE', image: require("../assets/colors/BLUE.png") },
        { key: 'PURPLE', text: 'Purple', value: 'PURPLE', image: require("../assets/colors/PURPLE.png") },
        { key: 'BLACK', text: 'Black', value: 'BLACK', image: require("../assets/colors/BLACK.png") },
        { key: 'BROWN', text: 'Brown', value: 'BROWN', image: require("../assets/colors/BROWN.png") },
        { key: 'GRAY', text: 'Gray', value: 'GRAY', image: require("../assets/colors/GRAY.png") },
        { key: 'SILVER', text: 'Silver', value: 'SILVER', image: require("../assets/colors/SILVER.png") },
    ];

    static fantasyOptions: DropdownItemProps[] = [
        { key: 'MAGENTA', text: 'Magenta', value: 'MAGENTA', image: require("../assets/colors/MAGENTA.png") },
        { key: 'RED', text: 'Red', value: 'RED', image: require("../assets/colors/RED.png") },
        { key: 'CORAL', text: 'Coral', value: 'CORAL', image: require("../assets/colors/CORAL.png") },
        { key: 'ORANGE', text: 'Orange', value: 'ORANGE', image: require("../assets/colors/ORANGE.png") },
        { key: 'GOLDENROD', text: 'Goldenrod', value: 'GOLDENROD', image: require("../assets/colors/GOLDENROD.png") },
        { key: 'GOLD', text: 'Gold', value: 'GOLD', image: require("../assets/colors/GOLD_BORDER.png") },
        { key: 'LIGHT_GREEN', text: 'Light Green', value: 'LIGHT_GREEN', image: require("../assets/colors/LIGHT_GREEN.png") },
        { key: 'CHARTREUSE', text: 'Chartreuse', value: 'CHARTREUSE', image: require("../assets/colors/CHARTREUSE.png") },
        { key: 'GREEN', text: 'Green', value: 'GREEN', image: require("../assets/colors/GREEN.png") },
        { key: 'TEAL', text: 'Teal', value: 'TEAL', image: require("../assets/colors/TEAL.png") },
        { key: 'BLUE', text: 'Blue', value: 'BLUE', image: require("../assets/colors/BLUE.png") },
        { key: 'INDIGO', text: 'Indigo', value: 'INDIGO', image: require("../assets/colors/INDIGO.png") },
        { key: 'PURPLE', text: 'Purple', value: 'PURPLE', image: require("../assets/colors/PURPLE.png") },
        { key: 'BLACK', text: 'Black', value: 'BLACK', image: require("../assets/colors/BLACK.png") },
        { key: 'BROWN', text: 'Brown', value: 'BROWN', image: require("../assets/colors/BROWN.png") },
        { key: 'GRAY', text: 'Gray', value: 'GRAY', image: require("../assets/colors/GRAY.png") },
        { key: 'LIGHT_GRAY', text: 'Light Gray', value: 'LIGHT_GRAY', image: require("../assets/colors/LIGHT_GRAY.png") },
        { key: 'SILVER', text: 'Silver', value: 'SILVER', image: require("../assets/colors/SILVER.png") },

    ];

    public render() {
        const colorRows: JSX.Element[] = [];
        for (const color of this.props.historical ? ColorDropdownModal.historicalOptions : ColorDropdownModal.fantasyOptions) {
            colorRows.push(
                <div className="color-dropdown-modal-row" onClick={() => this.onChange(color.value as string)} key={color.key}>
                    <img id="color-dropdown-modal-row-img" src={color.image!} alt="select color"
                    // onClick={() => {
                    //     console.log ("ColorDropdownModal: clicked to closed");
                    //     this.props.onClose();
                    // }}
                    />
                    <div className="color-dropdown-modal-row_text">{color.text}</div>
                </div>);
        }

        return <Modal id="color-dropdown-modal"
            open={true} onClose={() => this.props.onClose()} closeIcon="x" closeOnEscape={true} closeOnDimmerClick={true}>
            <Modal.Content>
                <div className="wsCenter">
                    <div>
                        {colorRows}
                    </div>
                </div>
            </Modal.Content>
        </Modal>;
    }

    private onChange(color: string) {
        console.log("ColorDropdownModal.onChange: " + color);
        this.props.onChange(color);
        this.props.onClose();
    }
}

